import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "./AdmOtherDetails.css";
import { ApiUrl } from "../../../ApiUrl";
import {
  DOCUMENT_UPLOAD_OPTIONS,
  prepareUploadFile,
} from "../../utils/uploadUtils";

const AdmOtherDetails = ({ formData, setFormData }) => {
  const { id } = useParams();
  const [documentTypes, setDocumentTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const hasOnlyBlankDocumentRow = (rows) => {
    if (!Array.isArray(rows) || rows.length !== 1) {
      return false;
    }
    const row = rows[0] || {};
    return (
      !row.document_no &&
      !row.document_type &&
      !row.document_pic &&
      !row.preview_url
    );
  };

  // Initialize documentsDetails if not already set
  useEffect(() => {
    if (!formData.documentsDetails || formData.documentsDetails.length === 0) {
      setFormData((prevData) => ({
        ...prevData,
        documentsDetails: [
          {
            document_no: "",
            document_type: "",
            document_pic: "",
            start_from: "",
            end_to: "",
          },
        ],
      }));
    }
  }, [formData.documentsDetails, setFormData]);

  useEffect(() => {
    const shouldFetchDocuments =
      id &&
      (!Array.isArray(formData.documentsDetails) ||
        formData.documentsDetails.length === 0 ||
        hasOnlyBlankDocumentRow(formData.documentsDetails));

    if (!shouldFetchDocuments) {
      return;
    }

    const fetchStudentDocuments = async () => {
      try {
        const response = await fetch(
          `${ApiUrl.apiurl}STUDENTREGISTRATIONAPI/GetStudentDetailsBasedOnId/${id}`
        );
        const data = await response.json();
        const rawDocs =
          data?.data?.documents_details || data?.data?.documentsDetails || [];

        if (Array.isArray(rawDocs) && rawDocs.length > 0) {
          const mappedDocs = rawDocs.map((doc) => ({
            id: doc.id || null,
            document_no: doc.document_no || "",
            document_type: doc.document_type || "",
            document_pic: "",
            preview_url: doc.document_url || doc.document_pic || "",
            start_from: doc.start_from || "",
            end_to: doc.end_to || "",
          }));

          setFormData((prev) => ({
            ...prev,
            documentsDetails: mappedDocs,
          }));
        }
      } catch (fetchError) {
        console.error("Error fetching documents for tab:", fetchError);
      }
    };

    fetchStudentDocuments();
  }, [id, formData.documentsDetails, setFormData]);

  // Fetch document types
  useEffect(() => {
    const fetchDocumentTypes = async () => {
      try {
      const response = await fetch(`${ApiUrl.apiurl}DOCUMENT/GetAllDocumentList/`);
        const data = await response.json();
        if (data && Array.isArray(data.data)) {
          setDocumentTypes(data.data);
        } else {
          console.error("Unexpected data format:", data);
          setDocumentTypes([]);
        }
      } catch (error) {
        console.error("Error fetching document types:", error);
        setError("Failed to fetch document types.");
      } finally {
        setLoading(false);
      }
    };

    fetchDocumentTypes();
  }, []);

  const handleAddRow = () => {
    const incompleteDocuments = formData.documentsDetails.filter(
      (doc) => !doc.document_no
    );
    if (incompleteDocuments.length > 0) {
      alert(
        "Please fill in all required fields (Document No) for documents before adding a new one."
      );
      return;
    }

    setFormData((prev) => ({
      ...prev,
      documentsDetails: [
        ...prev.documentsDetails,
        {
          document_no: "",
          document_type: "",
          document_pic: "",
          start_from: "",
          end_to: "",
        },
      ],
    }));
  };

  const handleRemoveRow = (index) => {
    setFormData((prev) => ({
      ...prev,
      documentsDetails: prev.documentsDetails.filter((_, i) => i !== index),
    }));
  };

;

  const handleInputChange = (index, field, value) => {
    const updatedDocs = [...formData.documentsDetails];

    if (field === "document_type") {
      // If user changes document type and document_no is filled, reset document_no
      if (updatedDocs[index].document_no) {
        updatedDocs[index].document_no = "";
      }
    }

    updatedDocs[index][field] = value;

    setFormData((prev) => ({ ...prev, documentsDetails: updatedDocs }));
  };

  // const handleFileChange = (index, file) => {
  //   const updatedDocs = [...formData.documentsDetails];
  //   updatedDocs[index]["document_pic"] = file;
  //   setFormData((prev) => ({ ...prev, documentsDetails: updatedDocs }));
  // };

  //new code 07242025
 const handleFileChange = async (index, file) => {
   if (!file) return;

   // Allowed file formats
   const allowedTypes = [
     "application/pdf",
     "image/jpeg",
     "image/jpg",
     "image/png",
     "image/webp",
     "image/gif",
     "application/msword", // .doc
     "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
     "application/vnd.ms-excel", // .xls
     "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
     "text/plain", // .txt
   ];

   // Max file size = 500 KB
   const maxSize = 500 * 1024;

   // Validate file type
   if (!allowedTypes.includes(file.type)) {
     alert(
       "Invalid file format. Only PDF, JPG, JPEG, PNG, WEBP, GIF, DOC, DOCX, XLS, XLSX, and TXT files are allowed.",
     );
     return;
   }

   // Validate file size
   if (file.size > maxSize) {
     alert("File size must be less than or equal to 500 KB.");
     return;
   }

   try {
     const processedFile = await prepareUploadFile(
       file,
       DOCUMENT_UPLOAD_OPTIONS,
     );

     const updatedDocs = [...formData.documentsDetails];

     updatedDocs[index]["document_pic"] = processedFile;

     updatedDocs[index]["preview_url"] = URL.createObjectURL(processedFile);

     setFormData((prev) => ({
       ...prev,
       documentsDetails: updatedDocs,
     }));
   } catch (error) {
     alert(error.message || "Unable to prepare the selected document.");
   }
 };
  const handleSubmit = (event) => {
    event.preventDefault();
    const payload = new FormData();
    formData.documentsDetails.forEach((doc, index) => {
      payload.append(`documents[${index}][document_no]`, doc.document_no);
      payload.append(`documents[${index}][document_type]`, doc.document_type);
      payload.append(`documents[${index}][start_from]`, doc.start_from);
      payload.append(`documents[${index}][end_to]`, doc.end_to);
      if (doc.document_pic) {
        payload.append(`documents[${index}][document_pic]`, doc.document_pic);
      }
    });

    fetch("your_api_endpoint", {
      method: "POST",
      body: payload,
    })
      .then((response) => response.json())
      .then((data) => console.log("Success:", data))
      .catch((error) => console.error("Error:", error));
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <form onSubmit={handleSubmit} className="container-fluid form-container">
      <div className="table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th>S.No.</th>
              <th>
                Document Type<span className="red-text">*</span>
              </th>
              <th>
                Document No.<span className="red-text">*</span>
              </th>
              <th>
                Upload Document<span className="red-text">*</span>
              </th>
              <th>Remove</th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(formData.documentsDetails) &&
            formData.documentsDetails.length > 0 ? (
              formData.documentsDetails.map((row, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>

                  {/* <td>
                    <select
                      value={row.document_type}
                      onChange={(e) =>
                        handleInputChange(
                          index,
                          "document_type",
                          e.target.value
                        )
                      }
                      required
                    >
                      <option value="">Select Document Type</option>
                      {documentTypes.map((docType, i) => (
                        <option key={i} value={docType.documentcode}>
                          {docType.documentdesc}
                        </option>
                      ))}
                    </select>
                  </td> */}
                  <td>
                    <select
                      className="form-select"
                      value={row.document_type}
                      onChange={(e) =>
                        handleInputChange(
                          index,
                          "document_type",
                          e.target.value,
                        )
                      }
                      required
                    >
                      <option value="">Select Document Type</option>

                      {documentTypes.map((docType, i) => (
                        <option key={i} value={docType.documentcode}>
                          {docType.documentdesc}
                        </option>
                      ))}
                    </select>
                  </td>

                  <td>
                    <input
                      type="text"
                      value={row.document_no}
                      maxLength={
                        row.document_type === "Aadhar"
                          ? 12
                          : row.document_type === "PAN"
                            ? 10
                            : 100
                      }
                      onChange={(e) => {
                        const inputValue = e.target.value.toUpperCase();

                        if (row.document_type === "Aadhar") {
                          if (/^\d{0,12}$/.test(inputValue)) {
                            handleInputChange(index, "document_no", inputValue);
                          }
                        } else if (row.document_type === "PAN") {
                          if (
                            /^[A-Z]{0,5}[0-9]{0,4}[A-Z]{0,1}$/.test(inputValue)
                          ) {
                            handleInputChange(index, "document_no", inputValue);
                          }
                        } else {
                          handleInputChange(index, "document_no", inputValue);
                        }
                      }}
                      placeholder={
                        row.document_type === "Aadhar"
                          ? "Enter 12-digit Aadhaar number"
                          : row.document_type === "PAN"
                            ? "Enter 10-char PAN (e.g. ABCDE1234F)"
                            : "Enter Document Number"
                      }
                      required
                    />
                  </td>

                  <td>
                    <input
                      type="file"
                      accept=".pdf,.jpg,.jpeg,.png,.webp,.gif,.doc,.docx,.xls,.xlsx,.txt"
                      onChange={(e) =>
                        handleFileChange(index, e.target.files[0])
                      }
                    />
                    {row.preview_url && (
                      <div className="mt-2">
                        <a
                          href={row.preview_url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View Uploaded File
                        </a>
                      </div>
                    )}
                  </td>

                  {/* <td>
                    <input
                      type="date"
                      value={row.start_from}
                      onChange={(e) =>
                        handleInputChange(index, "start_from", e.target.value)
                      }
                    />
                  </td>

                  <td>
                    <input
                      type="date"
                      value={row.end_to}
                      onChange={(e) =>
                        handleInputChange(index, "end_to", e.target.value)
                      }
                    />
                  </td> */}

                  <td>
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={() => handleRemoveRow(index)}
                    >
                      Remove
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" style={{ textAlign: "center", color: "#888" }}>
                  No document records available.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="d-flex justify-content-end">
        <button
          type="button"
          className="btn btn-primary add-row"
          onClick={handleAddRow}
        >
          Add New Row
        </button>
      </div>
    </form>
  );
};

export default AdmOtherDetails;
